import React from 'react';
import { SvgIconTypeMap } from '@mui/material';
import { OverridableComponent } from '@mui/material/OverridableComponent';

// Define the props for your custom Icon component
interface CustomIconProps {
  // The 'IconComponent' prop will accept a Material UI SvgIcon component
  // which is typed as OverridableComponent<SvgIconTypeMap>
  IconComponent: OverridableComponent<SvgIconTypeMap<{}, 'svg'>>;
  // Any other props you want to pass to the underlying SvgIcon
  color?: 'primary' | 'secondary' | 'action' | 'error' | 'disabled' | 'inherit';
  fontSize?: 'small' | 'inherit' | 'large';
  // ... other SvgIcon props
}

const CustomIcon: React.FC<CustomIconProps> = ({ IconComponent, ...rest }) => {
  return <IconComponent {...rest} />;
};

export default CustomIcon;